import React, { useState, useEffect } from 'react'
import { firestore } from '../../firebase';
import EditLoanProvider from './EditLoanProvider';

function AllLoanProviders() {

    const [banker, setBanker] = useState([]);
    const [selected, setSelected] = useState(null);

    useEffect(() => {

        try {
            const loansRef = firestore.collection("renter");
            loansRef.orderBy("bank").onSnapshot(({docs}) => {
                const banker = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                })
                setBanker(banker)
            })
        } catch (error) {
            
        }

    }, [])

    return (
        <div>
            <ul className="list-group">
                {banker?.map((bank, index) => {
                    return (
                        <li className="list-group-item" key={index}>
                            {bank.bank} ({bank.rente_type}) 
                            <span className="float-right">
                                <i onClick={() => setSelected(bank)} className="fas fa-edit text-primary"></i> <i className="fas fa-trash text-danger"></i>
                            </span>
                        </li>
                    )
                })}
            </ul>
            {selected && <EditLoanProvider currentBank={selected} />}
        </div>
    )
}
export default AllLoanProviders